// Refresh categories emitted by MainDisplay.handleOpsActionConfirmed that
// require reloading the member store list (a store was created or linked to a
// POS location through chat, so the switcher and setup anchor store must
// pick it up; or feature flags changed, so the nav and landing tab must
// follow without a reload).
const MEMBER_STORE_CATEGORIES = ["locations", "features"];

export function shouldRefreshMemberStores(categories) {
  if (!Array.isArray(categories)) return false;
  return categories.some((category) => MEMBER_STORE_CATEGORIES.includes(category));
}

// Exclusive docking between the Rovis and Lumi panels. Docking is a boolean
// each panel keeps internally, so the parent decides purely from the widths
// the panels report: when one panel docks (width > 0) while the other is
// already docked (width > 0), the other must undock.
export function shouldUndockOther(dockedWidth, otherDockedWidth) {
  return dockedWidth > 0 && otherDockedWidth > 0;
}
